import 'prismjs';
import 'prismjs/components/prism-sql';
import {Amplify} from 'aws-amplify'

async function initAws() {
  const aws_user_pools_id = localStorage.getItem('aws_user_pools_id') || 'DUMMY';
  const aws_user_pools_web_client_id = localStorage.getItem('aws_user_pools_web_client_id') || "DUMMY";
  if (aws_user_pools_id && aws_user_pools_web_client_id) {
    Amplify.configure({
      Auth: {

        Cognito: {
          userPoolId: aws_user_pools_id,
          userPoolClientId: aws_user_pools_web_client_id,

        },

      },

    });
  }

}


initAws().then(() => import('./bootstrap'))
  .catch(err => console.error(err));


